import { updatesData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '热': 'bg-accent-100 text-accent-700',
  '爆': 'bg-accent-500 text-background-50',
  '新': 'bg-secondary-100 text-secondary-700',
};

export default function SectionUpdates() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            实时快讯
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">最新动态</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">7×24小时不间断追踪，重大爆料第一时间推送</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative group">
                <div className="absolute -left-[31px] md:-left-[35px] top-1.5 w-3 h-3 rounded-full bg-primary-400 border-2 border-background-100/70"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs font-mono text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed group-hover:text-foreground-900 transition-colors duration-200">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}